<div class="auth-container">
  <div class="auth-layout">
    <!-- Left Side - Sign In Form -->
    <div class="auth-left">
      <!-- VHI Logo - Top Left -->
      <div class="auth-logo-header">
        <img src="../../../assets/img/vhi_logo.png" alt="Company Logo" />
      </div>
      <div class="auth-form-container">

        <div class="auth-form">
          <h2 class="sign-in-title">Sign in</h2>
          
              <form (ngSubmit)="signIn()" (keydown.enter)="signIn()">
                <div class="form-group mb-4">
                  <input 
                    type="email" 
                    id="email" 
                    name="email" 
                    #email="ngModel" 
                    [(ngModel)]="user.email" 
                    class="form-control"
                    placeholder="Enter your email"
                    autocomplete="email">
                </div>

                <div class="form-group mb-4">
                  <div class="input-group">
                    <input 
                      [type]="user.showPassword ? 'text' : 'password'" 
                      id="password" 
                      name="password" 
                      #password="ngModel" 
                      [(ngModel)]="user.password" 
                      class="form-control"
                      placeholder="Enter your password"
                      autocomplete="current-password">
                    <button 
                      type="button" 
                      class="btn btn-outline-secondary" 
                      (click)="user.showPassword = !user.showPassword">
                      <i class="bi" [ngClass]="{'bi-eye-fill': !user.showPassword, 'bi-eye-slash-fill': user.showPassword}"></i>
                    </button>
                  </div>
                </div>

            <div class="d-grid gap-2 mb-4">
              <button 
                type="submit" 
                class="btn btn-primary btn-lg" 
                [disabled]="loading">
                <span class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true" *ngIf="loading"></span>
                Sign in
              </button>
            </div>
          </form>

          <div class="text-center mt-4">
            <a href="" [routerLink]="['/resetPassword']" class="text-muted text-decoration-none">
              Forgot your password?
            </a>
          </div>

          <p class="text-center text-muted mt-5">
            New here? <a href="" [routerLink]="['/signUp']" class="text-primary">Create an account</a>
          </p>
        </div>
      </div>
    </div>

        <!-- Right Side - Gradient Background with Slides -->
        <div class="auth-right">
          <div class="gradient-background">
            <div class="slides-container">
              <div class="slide" [class.active]="currentSlide === 0">
                <img src="../../../assets/img/backgrounds/sign-in-slide-1.svg" alt="Slide 1" />
              </div>
              <div class="slide" [class.active]="currentSlide === 1">
                <img src="../../../assets/img/backgrounds/sign-in-slide-2.svg" alt="Slide 2" />
              </div>
              <div class="slide" [class.active]="currentSlide === 2">
                <img src="../../../assets/img/backgrounds/sign-in-slide-3.svg" alt="Slide 3" />
              </div>
            </div>
          </div>
        </div>
  </div>
</div>
  